export type InviteRow = {
  id: number
  code: string
  createdAt: string
  expiresAt: string
  maxClaims: number
  claimsCount: number
  note: string | null
  revokedAt: string | null
  url: string
}

export function inviteStatus(invite: InviteRow): string {
  if (invite.revokedAt) return 'Ingetrokken'
  if (new Date(invite.expiresAt).getTime() <= Date.now()) return 'Verlopen'
  if (invite.claimsCount >= invite.maxClaims) return 'Opgebruikt'
  return 'Actief'
}

export function toDatetimeLocalValue(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function formatShortDate(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('nl-BE', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}
